module.exports = __webpack_public_path__ + "img/faq.e71c2926.jpg";